<form
  class="check-in !flex w-full flex-col items-center laptop:gap-[8px] ultrawide:gap-[12px]"
  [formGroup]="checkInWidgetForm"
  (ngSubmit)="formSubmit($event)"
  id="mach-core-check-in-form"
>
  <section
    *ngIf="initService.errorContent.showAlert"
    class="check-in__alert flex justify-center mb-16"
    id="mach-core-check-in-alert"
  >
    <idp-error-message
      [errorMessage]="'To continue, please correct the'"
      [cntError]="initService.errorContent.errorCount"
      (firstInvalidFieldFocusEvent)="focusFirstInvalidFieldHandler()"
    ></idp-error-message>
  </section>
  <div
    class="check-in__container container flex flex-col laptop:flex-row"
    id="mach-core-check-in-container"
  >
    <div
      class="check-in__content flex w-full flex-col items-center laptop:flex-row gap-[12px] laptop:gap-[0] mb-[16px] laptop:mb-0 px-16 py-16 laptop:py-0 laptop:px-0 rounded-03 bg-surface-02 shadow-01 laptop:rounded-none laptop:bg-transparent laptop:shadow-none"
      id="mach-core-check-in-content"
    >
      <div
        class="check-in__field check-in__field--trip-type laptop:flex laptop:self-baseline ultrawide:mr-[12px] laptop:mr-[12px]"
        [ngClass]="[
          initService.hideLastName
            ? 'w-[311px] tablet:w-[672px] laptop:w-[245px] ultrawide:w-[314px]'
            : 'w-[311px] tablet:w-[672px] laptop:w-[184px] ultrawide:w-[314px]'
        ]"
        id="mach-core-check-in-trip-type-field"
      >
        <div
          class="check-in__trip-by-selector dropdown w-[-webkit-fill-available]"
        >
          <button
            class="dropdown w-full h-[64px] !border-stroke-01"
            id="dropdownCheckIn"
          ></button>
          <input type="hidden" formControlName="findTripBy" />
        </div>
      </div>

      <div
        class="check-in__field check-in__field--trip-value relative"
        [ngClass]="[
          initService.hideLastName
            ? 'w-[311px] tablet:w-[672px] laptop:mr-[8px] laptop:w-[245px] ultrawide:w-[314px]'
            : 'w-[311px] tablet:w-[672px] laptop:mr-[12px] laptop:w-[184px] ultrawide:w-[276px]'
        ]"
        id="mach-core-check-in-trip-value-field"
      >
        <input
          #tripByValueInput
          id="input-trip-by-value"
          class="single-line-input peer w-icon !border-stroke-01 text-heading"
          placeholder="{{ checkInTextData.placeholder }}"
          [attr.aria-label]="checkInTextData.placeholder"
          formControlName="findTripByValue"
          [attr.aria-invalid]="
            initService.errorContent.showTripTypeError && !isTripByValueFocused
              ? 'true'
              : 'false'
          "
          (focus)="isTripByValueFocused = true"
          (blur)="isTripByValueFocused = false"
        />
        <label for="input-trip-by-value" class="static-title">
          {{ checkInTextData.inputLabel }}
        </label>
        <button
          *ngIf="
            initService.hideIcon &&
            checkInTextData?.modalHeader &&
            checkInTextData?.modalContent
          "
          class="grayscale-effect !cursor-pointer"
          onclick="pop_up_no_buttons.showModal()"
          [style.transform]="
            initService.errorContent.showTripTypeError ? 'translateY(-75%)' : ''
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="11.25" fill="#0066CC" />
            <path
              d="M12.4129 7.46709C12.4129 8.21878 12.9265 8.71129 13.7047 8.71129C14.5582 8.71129 15.2778 8.08955 15.2778 7.24699C15.2778 6.49603 14.7266 6 13.968 6C13.1347 6 12.4129 6.66156 12.4129 7.46709Z"
              fill="white"
            />
            <path
              d="M9.28418 16.9905C9.28418 17.6898 9.7608 18 10.4407 18C12.3587 18 14.5754 15.7281 14.5754 15.1951C14.5754 15.0323 14.4432 14.9212 14.3491 14.9212C14.241 14.9212 14.0048 15.178 13.7245 15.4829C13.3141 15.9291 12.809 16.4784 12.4708 16.4784C12.319 16.4784 12.2437 16.3492 12.2437 16.2234C12.2437 15.9644 12.4067 15.5752 12.5226 15.2987L12.5656 15.1951L13.9325 11.6245C14.6146 9.84933 13.7422 9.3701 12.9265 9.3701C11.8286 9.3701 10.8406 9.90102 10.082 10.5997L10.0109 10.6677C9.70514 10.9599 9 11.6337 9 11.9347C9 12.0465 9.11206 12.1736 9.24664 12.1736C9.38763 12.1736 9.62476 11.9036 9.90399 11.5858C10.3033 11.1312 10.7886 10.5787 11.2015 10.5787C11.3513 10.5787 11.5226 10.7449 11.3895 11.0761L10.0631 14.2995C9.92944 14.6104 9.28418 16.1137 9.28418 16.9905Z"
              fill="white"
            />
          </svg>
        </button>
        <div
          *ngIf="initService.errorContent.showAlert"
          class="mt-[8px] laptop:min-h-[16px]"
        >
          <div
            *ngIf="initService.errorContent.showTripTypeError"
            class="text-caption-medium text-alert"
          >
            {{ initService.errorContent.tripTypeError }}
          </div>
        </div>
      </div>

      <div
        [ngClass]="{ hidden: initService.hideLastName }"
        class="check-in__field check-in__field--last-name relative w-[311px] tablet:w-[672px] laptop:mr-[12px] laptop:w-[184px] ultrawide:mr-[12px]"
        id="mach-core-check-in-last-name-field"
      >
        <input
          #lastNameInput
          id="input-last-name"
          class="single-line-input peer !border-stroke-01"
          placeholder="{{ content.accessibility.lastNameAriaLabel }}"
          [attr.aria-label]="content.accessibility.lastNameAriaLabel"
          formControlName="lastName"
          [attr.aria-invalid]="
            initService.errorContent.showLastNameError && !isLastNameFocused
              ? 'true'
              : 'false'
          "
          (focus)="isLastNameFocused = true"
          (blur)="isLastNameFocused = false"
        />
        <label for="input-last-Name" class="static-title">
          {{ content.labels.lastNameLabel }}
        </label>
        <div
          *ngIf="initService.errorContent.showAlert"
          class="mt-[8px] laptop:min-h-[16px]"
        >
          <div
            *ngIf="initService.errorContent.showLastNameError"
            class="text-caption-medium text-alert"
          >
            {{ initService.errorContent.lastNameError }}
          </div>
        </div>
      </div>

      <div
        class="check-in__field check-in__field--airport check-in-widget__from-and-to relative"
        [ngClass]="[
          initService.hideLastName
            ? 'w-[311px] tablet:w-[672px] laptop:mr-[24px] laptop:w-[245px] ultrawide:w-[314px]  ultrawide:mr-[32px]'
            : 'w-[311px] tablet:w-[672px] laptop:mr-[24px] laptop:w-[184px]'
        ]"
        id="mach-core-check-in-airport-field"
      >
        <input
          #fromAirportInput
          id="input-from-airport"
          class="single-line-input peer cursor-pointer bg-white !border-stroke-01 !p-0 !pl-[15px]"
          placeholder="{{ content.accessibility.fromAirportAriaLabel }}"
          [attr.aria-label]="content.accessibility.fromAirportAriaLabel"
          formControlName="originAirportCode"
          [attr.aria-invalid]="
            initService.errorContent.showOriginAirportError &&
            !isFromAirportFocused
              ? 'true'
              : 'false'
          "
          style="border-color: #80859c; background-color: white"
          readonly
          (click)="openSearchModal()"
          (keydown.enter)="openSearchModal()"
          (focus)="isFromAirportFocused = true"
          (blur)="isFromAirportFocused = false"
        />
        <div
          *ngIf="initService.errorContent.showAlert"
          class="mt-[8px] laptop:min-h-[16px]"
        >
          <div
            *ngIf="initService.errorContent.showOriginAirportError"
            class="text-caption-medium text-alert"
          >
            {{ initService.errorContent.originAirportError }}
          </div>
        </div>
      </div>
    </div>
    <div class="check-in__actions" id="mach-core-check-in-actions">
      <button
        #searchButton
        type="submit"
        class="check-in__button check-in__from-and-to button button-primary button-lg h-16 w-full text-label-md-semibold laptop:w-[145px] ultrawide:w-[154px]"
        [attr.aria-label]="content.accessibility.buttonAriaLabel"
        data-acdl-name="check-in:search"
        data-acdl-action="header:check-in:search"
        data-acdl-page-section="header:check-in:search"
        (click)="isIntentionalSubmit = true; analyticsEvent.emit(searchButton)"
        id="mach-core-check-in-submit-button"
      >
        {{ content.labels.buttonLabel }}
      </button>
    </div>
    <dialog
      id="pop_up_no_buttons"
      class="pop-up"
      aria-labelledby="pop-up-title"
      aria-describedby="pop-up-description"
      aria-modal="true"
      role="dialog"
    >
      <div class="pop-up-box" id="mach-core-check-in-modal-box">
        <div
          class="pop-up-box-header border-none"
          id="mach-core-check-in-modal-header"
        >
          <h2 id="pop-up-title" class="text-label-xl-semibold text-heading">
            {{ checkInTextData.modalHeader }}
          </h2>
          <button
            onclick="pop_up_no_buttons.close()"
            class="pop-up-box-header-close-button"
            aria-label="Close pop-up"
            id="mach-core-check-in-modal-close"
          >
            <div class="pop-up-box-header-close-button-icon"></div>
          </button>
        </div>
        <div class="pop-up-box-content" id="mach-core-check-in-modal-content">
          <p id="pop-up-description" class="text-body-sm text-body-copy">
            {{ checkInTextData.modalContent }}
          </p>
        </div>
      </div>
      <form method="dialog" class="pop-up-backdrop">
        <button aria-label="Close pop-up">Close</button>
      </form>
    </dialog>
  </div>
</form>
